import {MapCurrentPosiotionModel} from './type';

export default {
    namespace: 'map',

    state: {
        currentPosition: null,
    },

    effects: (dispatch: any) => ({
        setCurrentPosition(locationInfo: MapCurrentPosiotionModel) {
            dispatch.map.setCurrentPosition_reducer(locationInfo);
        },
    }),

    reducers: {
        setCurrentPosition_reducer(state: any, payload: MapCurrentPosiotionModel) {
            return {...state, currentPosition: payload};
        },
    },
};
